export const product1 = [
    {
        id: "12321341",
        title: "The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback",
        price: 11.96,
        rating: 5,
        image: "https://images-na.ssl-images-amazon.com/images/I/51Zymoq7UnL._SX325_BO1,204,203,200_.jpg",
    },
    {
        id: "49538094",
        title: "Kenwood kMix Stand Mixer for Baking, Stylish Kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre Glass Bowl",
        price: 239.0,
        rating: 4,
        image: "https://images-na.ssl-images-amazon.com/images/I/81O%2BGNdkzKL._AC_SX450_.jpg",
    },


]
export const product2 = [
    {
        id: "4903850",
        title: "Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor",
        price: 199.99,
        rating: 3,
        image: "https://images-na.ssl-images-amazon.com/images/I/71Swqqe7XAL._AC_SX466_.jpg",
    },
    {
        id: "23445930",
        title: "Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric",
        price: 98.99,
        rating: 5,
        image: "https://media.very.co.uk/i/very/P6LTG_SQ1_0000000071_CHARCOAL_SLf?$300x400_retinamobilex2$",
    },
    {
        id: "3254354345",
        title: "New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)",
        price: 598.99,
        rating: 4,
        image: "https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg",
    },
]
export const product3 = [
    {
        id: "90829332",
        title: "Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor - Super Ultra Wide Dual WQHD 5120 x 1440",
        price: 1094.98,
        rating: 4,
        image: "https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg",
    },
]
export const product4 = [
    {
        id: '1',
        title: 'JGD PRODUCTS USB 3.0 to Type-C  ',
        price: 2.50,
        rating: 4,
        image: "https://images-eu.ssl-images-amazon.com/images/I/41JhVoj3oxL._AC_UL160_SR160,160_.jpg",
    },
    {
        id: '2',
        title: 'Redgear MP35 Speed-Type ',
        price: 10.99,
        rating: 5,
        image: "https://images-eu.ssl-images-amazon.com/images/I/61G5-hNFMYL._AC_UL160_SR160,160_.jpg",
    },
    {
        id: '3',
        title: 'XPG ADATA GAMMIX D30 DDR4 8GB (1x8GB) 3200MHz ',
        price: 50.89,
        rating: 4,
        image: "https://images-eu.ssl-images-amazon.com/images/I/81lTPWJ+QZL._AC_UL160_SR160,160_.jpg",
    },
    {
        id: '4',
        title: 'Zebronics Zeb-Transformer Gaming Keyboard ',
        price: 20.99,
        rating: 4,
        image: "https://images-eu.ssl-images-amazon.com/images/I/61l3aUqHRVL._AC_UL160_SR160,160_.jpg",
    },


]

export const product5 = [
    {
        id: '5',
        title: 'Ant Esports Superflow 120 Auto RGB V2 1200 RPM',
        price: 40.69,
        rating: 5,
        image: "https://images-eu.ssl-images-amazon.com/images/I/81fXrcPQ7QL._AC_UL160_SR160,160_.jpg",
    },
    {
        id: '6',
        title: 'Storin Long Extended Waterproof Foldable MousePad',
        price: 10.99,
        rating: 5,
        image: "https://images-eu.ssl-images-amazon.com/images/I/51hRCLGSazL._AC_UL160_SR160,160_.jpg",
    },
    {
        id: '7',
        title: 'makerV Headphone Holder Gaming Headset',
        price: 29.99,
        rating: 3,
        image: "https://images-eu.ssl-images-amazon.com/images/I/51LNlnj8R4L._AC_UL160_SR160,160_.jpg",
    },
    {
        id: '8',
        title: 'Logitech G402 Hyperion Fury Wired Gaming Mouse',
        price: 79.99,
        rating: 5,
        image: "https://images-eu.ssl-images-amazon.com/images/I/61CqLgubwoL._AC_UL160_SR160,160_.jpg",
    },
]
export const product6 = [
    {
        id: '9',
        title: 'Redgear Blaze 7 Colour Backlit',
        price: 60.39,
        rating: 4,
        image: "https://images-eu.ssl-images-amazon.com/images/I/81nlglNR3GL._AC_UL160_SR160,160_.jpg",
    },
    {
        id: '10',
        title: 'Redgear Pro Series Wired Gamepad Plug',
        price: 49.99,
        rating: 2,
        image: "https://images-eu.ssl-images-amazon.com/images/I/81f4ZAbIp7L._AC_UL160_SR160,160_.jpg",
    },
    {
        id: '11',
        title: 'Redragon Gainer M610',
        price: 45.55,
        rating: 4,
        image: "https://images-eu.ssl-images-amazon.com/images/I/51C2g8sqjZL._AC_UL160_SR160,160_.jpg",
    },
    {
        id: '12',
        title: 'Cosmic Byte CB-GK-02 Corona Wired Gaming',
        price: 75.99,
        rating: 1,
        image: "https://images-eu.ssl-images-amazon.com/images/I/71ftnIeMlTL._AC_UL160_SR160,160_.jpg",
    },
]